<template>
  <div class="edit-base edit-base-box" :class="{ 'default_edit-base': isDefault }">
    <div class="edit-base-item">
      <div class="span">
        <span class="spantitle">标题设置</span>
        <el-input v-model="shareTitle" :maxlength="60" @input="handleTitleInput" placeholder="请输入30字以内的文本信息"></el-input>
        <span v-if="!showDateFront">
          <span class="title-show" v-show="showName">&lt;名称&gt;</span>
          <span class="title-show" v-show="showDate">&lt;刊期&gt;</span>
        </span>
        <span v-if="showDateFront">
          <span class="title-show" v-show="showDate">&lt;刊期&gt;</span>
          <span class="title-show" v-show="showName">&lt;名称&gt;</span>
        </span>
      </div>
      <div class="title-content" v-if="isDefault">
        <el-checkbox v-model="showName" label="报纸名称"></el-checkbox>
        <el-checkbox v-model="showDate" label="报纸刊期"></el-checkbox>
        <el-select v-model="dateFormat" :disabled="!showDate" size="mini">
          <el-option :value="1" label="20yy年mm月dd日"></el-option>
          <el-option :value="2" label="20yy/mm/dd"></el-option>
          <el-option :value="3" label="20yy-mm-dd"></el-option>
          <el-option :value="4" label="20yymmdd"></el-option>
          <el-option :value="5" label="yy年mm月dd日"></el-option>
          <el-option :value="6" label="yy/mm/dd "></el-option>
          <el-option :value="7" label="yy-mm-dd"></el-option>
          <el-option :value="8" label="yymmdd"></el-option>
        </el-select>
        <el-checkbox v-model="showDateFront" label="刊期在前"></el-checkbox>
      </div>
    </div>
    <div class="edit-base-item">
      <span>微信摘要设置</span>
      <el-input v-model="shareDesc" type="textarea" resize="none" :maxlength="100" placeholder="请输入100字以内文本信息，例如：该报刊简介和特色等"> </el-input>
    </div>
    <div class="edit-base-item share">
      <span>微信链接封面</span>
      <input type="file" id="uploads" ref="uploadThum" value="imgFile" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event)" style="display:none" />
      <label for="uploads" class="base_content">
        <template v-if="thumbnail">
          <img :src="thumbnail" alt="" />
        </template>
        <template v-if="!thumbnail">
          <img src="@imgs/share.png" alt="" />
        </template>
        <div>上传链接封面</div>
      </label>
      <CropDialog ref="crop" :cropImgUrl="cropImgUrl" @cropConfirm="cropConfirm"></CropDialog>
    </div>
    <div class="edit-base-item" v-if="!isDefault">
      <div class="read-classify">
        刊期设置
        <el-tooltip effect="dark" :content="title" placement="top" popper-class="read-classify-tip" v-if="false">
          <img src="@imgs/switch-book-tip.png" alt="" class="question" />
        </el-tooltip>
      </div>
      <el-select class="personal-item-select" size="mini" v-model="classify" :disabled="isChangeType">
        <el-option v-for="item in classifyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="edit-base-item" v-if="!isDefault && isPaper" v-show="classify === 1">
      <span>报刊名称</span>
      <el-select class="personal-item-select" size="mini" v-model="baozhiId">
        <el-option v-for="item in baokanNames" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="edit-base-item" v-if="!isDefault" v-show="classify === 1">
      <span>发行日期</span>
      <el-date-picker :picker-options="pickerOptions" v-model="issuingDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
    </div>
    <div class="edit-base-item" v-if="!isDefault" v-show="classify === 0">
      <span>出版年份</span>
      <el-select class="personal-item-select" size="mini" v-model="publicationYear" placeholder="请选择年份">
        <el-option v-for="(item, index) in publicationYearOptions" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
import CropDialog from './CropDialog'
import { getCurDate, isPureNum } from '@/utils'
import api from '@api/getBook.js'
export default {
  name: 'editBase',
  data() {
    return {
      cropImgUrl: '',
      classify: 1, //读物分类
      issuingDate: '', //默认发行日期
      publicationYear: '', //默认出版年份
      date: '',
      classifyOptions: [
        // {
        //   value: '',
        //   label: '不开启'
        // },
        {
          value: 1,
          label: '日报'
        }
        // {
        //   value: 0,
        //   label: '期刊'
        // }
      ],
      dateFormat: '',
      showName: false,
      showDate: false,
      showDateFront: false,
      baokanNames: [],
      historyBaokanList: [],
      timeArr: [],
      publicationYearOptions: [],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      title:
        '为电子书刊设置刊期，可实现阅读时快速切换查看往期内容的效果。支持设置“日报”或“期刊”两种类型。“日报”可按照具体日期查看；“期刊”可按照年份浏览。另需将您想要快速切换的电子书刊添加到同一专辑内，请前往专辑设置。',
      isChangeType: false
    }
  },
  props: {
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    bookData: {
      handler(val) {
        // 若不存在则默认空
        this.classify = val.category === undefined ? (this.isPaper ? 1 : '') : val.category
        if (this.classify === 1) {
          if (val.publishDate) {
            if (this.isPaper) {
              let date = new Date(val.publishDate)
              this.issuingDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
            } else {
              this.issuingDate = val.publishDate
            }
          } else {
            this.issuingDate = null
          }
        } else if (this.classify === 0) {
          this.publicationYear = val.publishDate
        } else {
          this.initDate()
        }
      },
      deep: true
    }
  },
  components: {
    CropDialog
  },
  computed: {
    shareTitle: {
      get: function() {
        return this.$store.state.config.bookObj.shareTitle
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_TITLE_MESSAGE', newValue)
      }
    },
    shareDesc: {
      get: function() {
        return this.$store.state.config.bookObj.shareDesc
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_TITLE_DESC', newValue)
      }
    },
    baozhiId: {
      get: function() {
        if (this.$store.state.config.bookObj.baozhiId) {
          this.loadHistoryBaokanList(this.$store.state.config.bookObj.baozhiId)
        }
        return this.$store.state.config.bookObj.baozhiId || ''
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BAOZHIID', newValue)
      }
    },
    thumbnail: {
      get: function() {
        let url = this.$store.state.config.bookObj.thumbnail
        return url === 'default' ? false : url
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_THUMBNAIL', newValue)
      }
    },
    bookData() {
      return this.$store.state.book.bookData
    },
    isPaper() {
      return this.$store.state.book.isPaper
    },
    getQueryId() {
      return isPureNum(this.$route.query.id)
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    uploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        _this.cropImgUrl = res.target.result
        _this.thumbnail = res.target.result
        _this.$refs.uploadThum.value = ''
        _this.$refs.crop.dialogVisible = true
        _this.$nextTick(() => {
          _this.$refs.crop.init()
        })
      }
    },
    initDate() {
      const result = getCurDate()
      this.publicationYearOptions = []
      this.publicationYear = result.year
      this.issuingDate = result.curDate
      for (let i = 2000; i <= this.publicationYear; i++) {
        this.publicationYearOptions.push({ value: i, label: i + '年' })
      }
    },
    iconRight() {
      // 日期组件图标移动到右侧
      let keyNode = document.querySelector('.el-date-editor')
      let iNode = document.createElement('i')
      iNode.setAttribute('class', 'el-icon-date') // el-icon-bottom
      keyNode.appendChild(iNode)
      iNode.style.position = 'absolute'
      iNode.style.top = '5px'
      iNode.style.right = '38px'
      iNode.style.color = '#C0C4CC'
    },
    judgeIsClassify() {
      // 判断是否在期刊或者报纸类的专辑里，如果在不能改变读物种类，不在不作处理
      const params = { bookId: this.getQueryId }
      api.canEditCategory(params).then((res) => {
        if (res.status == 200 && res.data && res.data.code == 0) {
          this.isChangeType = !res.data.data
        }
      })
    },
    cropConfirm(file) {
      this.$store.commit('config/UPDATE_THUMBNAIL', file)
      document.querySelector('#uploads').value = ''
    },
    getBaoZhiByPage() {
      const params = {
        pageNo: 1,
        pageSize: 100,
        userName: this.userName
      }
      api.getBaoZhiByPage(params).then((res) => {
        if (res.status == 200 && res.data && res.data.status == 0) {
          this.baokanNames = res.data.data.content
        }
      })
    },
    loadHistoryBaokanList(id) {
      const params = { id: id }
      api.getEpapersByBaoZhiId(params).then((res) => {
        if (res.status == 200 && res.data && res.data.status == 0) {
          let data = res.data.data
          this.timeArr = []
          for (let a in data) {
            if (data.hasOwnProperty(a)) {
              if (data[a].id == this.getQueryId) {
                continue
              }
              let date = new Date(data[a].publishDate)
              this.timeArr.push(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate())
            }
          }
          this.historyBaokanList = data
        }
      })
    },
    handleTitleInput() {
      // 计算当前输入的字节长度
      let byteLength = 0
      for (let i = 0; i < this.shareTitle.length; i++) {
        const charCode = this.shareTitle.charCodeAt(i)
        // 判断字符是否为单字节或者双字节
        byteLength += charCode >= 0 && charCode <= 255 ? 1 : 2
        if (byteLength > 60) {
          // 如果超出最大字节长度，截取到正确的位置
          this.shareTitle = this.shareTitle.substring(0, i)
          break
        }
      }
    },
    disabledDate(time) {
      const jsTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
      return this.timeArr.includes(jsTime)
    }
  },
  mounted() {
    if (!this.isPaper) {
      this.classifyOptions = [
        {
          value: '',
          label: '不开启'
        },
        ...this.classifyOptions,
        {
          value: 0,
          label: '期刊'
        }
      ]
      this.classify = ''
    }
    this.$nextTick(() => {
      this.initDate()
      if (!this.isDefault) {
        this.iconRight()
        this.judgeIsClassify()
      }
      if (this.isPaper) {
        this.getBaoZhiByPage()
      }
    })
  }
}
</script>
<style lang="scss">
.edit-base {
  font-size: 13px;
  padding: 0 20px;
  .edit-base-item {
    .el-input {
      flex: 1;
      height: 24px;
      input {
        height: 100%;
      }
      .el-input__inner {
        height: 20px;
        font-size: 14px;
        padding: 2px;
      }
    }
    margin-top: 10px;
    span {
      display: inline-block;
      margin-bottom: 3px;
    }
    .el-input {
      flex: 1;
      .el-input__inner {
        font-size: 14px;
        padding: 2px;
      }
    }
    .el-textarea {
      flex: 1;
      height: 74px;
      .el-textarea__inner {
        font-size: 14px;
        padding: 2px;
        height: 74px;
      }
    }
    &.share {
      position: relative;
      img {
        display: block;
        width: 150px;
        height: 150px;
      }
      div {
        position: absolute;
        bottom: 0;
        color: #fff;
        background-color: #df5813;
        width: 150px;
        text-align: center;
        font-size: 14px;
      }
    }
    .cropper-wrapper {
      width: 300px;
      height: 300px;
    }
  }
}
.edit-base-box {
  .edit-base-item {
    display: -webkit-flex;
    display: flex;
    .read-classify {
      display: -webkit-flex;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 12px;
      font-size: 14px;
      width: 80px;
      .question {
        height: 13px;
        margin-left: 3px;
      }
    }
    > .span {
      .spantitle {
        width: 70px;
        margin-right: 12px;
        text-align: right;
        height: 24px;
        width: 80px;
      }
    }
    > span {
      width: 70px;
      margin-right: 12px;
      text-align: right;
      height: 24px;
      width: 80px;
    }
    .el-input {
      width: 150px;
      .el-input__inner {
        width: 150px;
        height: 24px;
        padding-left: 7px;
        line-height: 24px;
      }
    }
    .el-textarea {
      .el-textarea__inner {
        width: 150px !important;
        height: 75px;
        padding-left: 7px;
      }
    }
    .el-input__icon {
      line-height: 25px;
    }
    .base_content {
      width: 88px;
      height: 88px;
      img {
        width: 100%;
        height: 100%;
      }
      div {
        width: 88px;
        height: 20px;
        font-size: 12px;
      }
    }
    .el-date-editor {
      position: relative;
      .el-input__inner {
        padding-left: 7px;
      }
      .el-input__inner::placeholder {
        color: #606266;
      }
      .el-input__prefix {
        display: none;
      }
    }
  }
  .share {
    margin-bottom: 18px;
  }
}
.default_edit-base {
  display: flex;
  flex-direction: row;
  .edit-base-item {
    margin-right: 36px;
    &:first-child {
      flex-direction: column;
    }
    .title-show {
      display: inline-block;
      height: 24px;
      border-radius: 5px;
      margin-left: 5px;
      background-color: #df5813;
      font-size: 15px;
      line-height: 24px;
      color: #f0f0f0;
    }
  }
  .title-content {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    width: 380px;
    flex-wrap: wrap;
    .el-checkbox {
      .el-checkbox__label {
        margin: 0;
      }
    }
  }
}
.read-classify-tip {
  width: 250px;
  font-size: 14px !important;
}
</style>
